import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PackageStatus } from '@/models'

interface DownloadPackagesCSVRequest {
  buildingId: number
  locations?: string[]
  status?: PackageStatus
  startDate?: number
  endDate?: number
  sort?: string
  limit?: number
  search?: string
  skip?: number
}

export const downloadPackagesCSV = async (params: DownloadPackagesCSVRequest): Promise<Blob> => {
  const { locations, ...rest } = params

  const response = await authAPI.get('/packages/export-csv', {
    params: {
      ...rest,
      // Note api did not accept locations[]= format
      ...(locations && locations.length > 0 && { location: locations.join(',') }),
    },
    responseType: 'blob',
  })
  return response.data
}

export const useDownloadPackagesCSV = () => {
  return useMutation({
    mutationFn: downloadPackagesCSV,
  })
}
